import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Message } from 'primeng/api';
import { forkJoin } from 'rxjs';
import { Cep } from 'src/app/admihair/api/dto/cep';
import { Conta } from 'src/app/admihair/api/dto/conta';
import { Contrato } from 'src/app/admihair/api/dto/contrato';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { ExceptionDto } from 'src/app/admihair/api/dto/exception/exception-dto';
import { Municipio } from 'src/app/admihair/api/dto/municipio';
import { Operacao } from 'src/app/admihair/api/dto/operacao';
import { ParcelaPagamento } from 'src/app/admihair/api/dto/parcela-pagamento';
import { TipoPagamento } from 'src/app/admihair/api/dto/tipo-pagamento';
import { TributacaoEmpresa } from 'src/app/admihair/api/dto/tributacao-empresa';
import { Uf } from 'src/app/admihair/api/dto/uf';
import { CepService } from 'src/app/admihair/service/cep.service';
import { ContaService } from 'src/app/admihair/service/conta.service';
import { ContratoService } from 'src/app/admihair/service/contrato.service';
import { EmpresaService } from 'src/app/admihair/service/empresa.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { MunicipioService } from 'src/app/admihair/service/municipio.service';
import { OperacaoFinanceiraService } from 'src/app/admihair/service/operacao-financeira.service';
import { ParcelaPagamentoService } from 'src/app/admihair/service/parcela-pagamento.service';
import { TipoPagamentoService } from 'src/app/admihair/service/tipo-pagamento.service';
import { TributacaoEmpresaService } from 'src/app/admihair/service/tributacao-empresa.service';
import { UfService } from 'src/app/admihair/service/uf.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { FormatacaoUtil } from 'src/app/admihair/util/formatacao-util';

@Component({
  selector: 'app-empresa-inserir',
  templateUrl: './empresa-inserir.component.html',
  styleUrls: ['./empresa-inserir.component.scss']
})
export class EmpresaInserirComponent implements OnInit {

  messages: Message[] = [{ severity: 'success', summary: 'Sucesso', detail: '' }];
  listaUfs: Uf[] = [];
  ufSelecionado?: Uf;
  isUfSelecionada: boolean = false;
  listaMunicipios: Municipio[] = [];
  municipioSelecionado?: Municipio;
  messagemVisivel: boolean = false;
  temDuasPalavras: boolean = false;
  contaPrincipal: boolean = true;
  erroSalvarContato: boolean = false;
  enderecoCep: Cep = { endereco: ' ', bairro: ' ' };
  date?: Date;
  exibirMensagemCep: boolean = false;
  bloquearCamposEndereco: boolean = true;
  trocarCamposEndereco: boolean = false;
  modoEdicaoLogradouro: boolean = false;
  modoEdicaoBairro: boolean = false;
  cnpjEncontrado: boolean = false;
  bloqueiaNumeroEComplemento: boolean = true;
  focoCampo: boolean = false;
  dataValida?: boolean = true;
  progressoRequisicao: boolean = false;

  constructor(private empresaService: EmpresaService,
    private tributacaoEmpresaService: TributacaoEmpresaService,
    private contratoService: ContratoService,
    private contaService: ContaService,
    private operacaoService: OperacaoFinanceiraService,
    private tipoPagamentoService: TipoPagamentoService,
    private parcelaPagamentoService: ParcelaPagamentoService,
    private utilStorageService: UtilStorageService,
    private municipioService: MunicipioService,
    private ufService: UfService,
    private erroService: ErroService,
    private cepService: CepService) { }

  @ViewChild('f') form?: NgForm;
  value?: string;

  // TODO ver a tabela  Tipo Recolhimento 

  ngOnInit(): void {
    this.listarUfs();
    this.modoEdicaoLogradouro = false;
    this.modoEdicaoBairro = false;
  }

  salvar() {
    this.progressoRequisicao = true;
    const empresa = this.form?.form.value;
    empresa.administradora = this.utilStorageService.getAdministradora();
    empresa.ativo = true;
    if (this.trocarCamposEndereco) {
      empresa.uf = this.enderecoCep.estado;
      empresa.cidade = FormatacaoUtil.removerCaracteresEspeciais(this.enderecoCep.cidade);
    } else {
      empresa.uf = this.ufSelecionado?.siglaUf;
      empresa.cidade = FormatacaoUtil.removerCaracteresEspeciais(this.municipioSelecionado?.descricao);
      const cepDigitado: Cep = {
        cep: empresa.cep,
        endereco: empresa.logradouro,
        bairro: empresa.bairro,
        cidade: empresa.cidade,
        estado: empresa.uf
      }
      this.salvarCep(cepDigitado);
    }
    console.log('empresa: ', empresa);
    this.empresaService.salvar(empresa).subscribe({
      next: (data: Empresa) => {
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.salvarContrato(data);
        this.salvarTributacao(data);
      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
        this.progressoRequisicao = false;

      }
    }
    );
  }

  salvarContrato(empresa?: Empresa) {
    const contrato: Contrato = {
      razaoSocial: empresa?.razaoSocial,
      cnpj: empresa?.cnpjCpf,
      tipo: 0,
      empresa: empresa,
      ativoContratante: true,
      contratoAceito: true,
      excluido: false,
      ativoContratado: false
    }
    this.contratoService.salvar(contrato).subscribe({
      next: (data: Contrato) => {
        this.progressoRequisicao = false;
        this.limparFormulario();
        this.rolarTela();
      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
        this.progressoRequisicao = false;
      }
    })
  }

  salvarTributacao(empresa?: Empresa) {
    const tipos = ['DANFE', 'RPS'];
    for (const tipo of tipos) {
      const tributacaoEmpresa: TributacaoEmpresa = {
        empresaId: empresa?.id,
        razaoSocial: empresa?.razaoSocial,
        nomeFantasia: empresa?.nomeFantasia,
        cnpj: empresa?.cnpjCpf,
        fone: empresa?.telefone,
        crt: 'SIMPLES_NACIONAL',
        logradouro: empresa?.logradouro,
        numeroLogradouro: empresa?.numero,
        complementoLogradouro: empresa?.complemento,
        bairro: empresa?.bairro,
        cidade: empresa?.cidade,
        uf: empresa?.uf,
        cep: empresa?.cep,
        tipoRegistro: tipo,
        moduloHabilitado: false,
        excluido: false,
        pIbsUf: tipo === 'DANFE' ? 0 : undefined,
        pIbsMun: tipo === 'DANFE' ? 0 : undefined,
        pCbs: tipo === 'DANFE' ? 0 : undefined

      }
      this.tributacaoEmpresaService.salvar(tributacaoEmpresa).subscribe({
        next: (data: TributacaoEmpresa) => {
          console.log('salvou tributacao: ', data)
        },
        error: (err: any) => {
          console.log(err)
        }
      })

    }
  }

  listarUfs() {
    this.ufService.listarUf().subscribe({
      next: (data: Uf[]) => {
        this.listaUfs = data;
      },
      error: (err: any) => {
        console.log('erro ao consultar uf', err);
      }
    }
    )

    const fusoHorarioNavegador = Intl.DateTimeFormat().resolvedOptions().timeZone;
    console.log(fusoHorarioNavegador);

  }

  listarMunicipios() {
    if (this.ufSelecionado !== undefined && this.ufSelecionado !== null) {
      this.isUfSelecionada = true;
      this.municipioService.listarMuniciosPorUf(this.ufSelecionado.codigoUf).subscribe({
        next: (data: Municipio[]) => {
          this.listaMunicipios = data;
        },
        error: (err: any) => {
          console.log('erro ao consultar municipio', err);
        }
      }
      )
    }

  }


  consultarCep() {
    var cep = this.form?.value.cep;
    if (cep !== '' && cep !== undefined) {
      this.cepService.buscarPorCodigo(cep).subscribe({
        next: (data: Cep) => {
          this.enderecoCep = data;
          if (!this.enderecoCep.endereco) {
            this.modoEdicaoLogradouro = true;
            this.exibirMensagemCep = true;
          } else {
            this.modoEdicaoLogradouro = false;
            this.exibirMensagemCep = false;
          }
          if (!this.enderecoCep.bairro) {
            this.modoEdicaoBairro = true;
            this.exibirMensagemCep = true;
          } else {
            this.modoEdicaoBairro = false;
            this.exibirMensagemCep = false;
          }
          this.trocarCamposEndereco = true;
          this.bloquearCamposEndereco = true;
          this.bloqueiaNumeroEComplemento = false;
        },
        error: (err: any) => {
          console.log('cep nao encontrado')
          this.enderecoCep = { endereco: ' ', bairro: ' ' };
          this.exibirMensagemCep = true;
          this.trocarCamposEndereco = false;
          this.bloquearCamposEndereco = false;
          this.modoEdicaoLogradouro = true;
          this.modoEdicaoBairro = true;
          this.bloqueiaNumeroEComplemento = false;
          this.focoCampo = true;


        }
      });
    } else {
      this.bloqueiaNumeroEComplemento = true;
    }
  }

  salvarCep(cep: Cep) {

    this.cepService.salvar(cep).subscribe({
      next: (data: Cep) => {
        console.log('cep salvo:', data)
      },
      error: (err: any) => {
        console.log('erro ao salvar cep:', err)
      }
    });
  }

  buscarCnpjFranqui() {

    const cnpjCpf = this.form?.value.cnpjCpf;

    if (cnpjCpf) {
      this.empresaService.listarPorCnpjCpf(cnpjCpf).subscribe({
        next: () => {
          this.cnpjEncontrado = true;
        },
        error: (err: any) => {
          console.log(err);
          this.cnpjEncontrado = false;

        }
      });
    } else {
      console.log('cnpj inválido ou vazio')
      this.cnpjEncontrado = false;
    }

  }

  liberaCampo(item: string): boolean {
    return item ? true : false;
  }
  camposPreenchendo() {
    this.exibirMensagemCep = false;
  }

  tratarErroApi(exceptions: ExceptionDto[]) {
    if (exceptions.length > 0) {
      this.messages = [{ severity: 'error', summary: exceptions[0].requestId, detail: exceptions[0].data[0].message }];
    }
  }

  ocultarMensagem() {
    if (this.messagemVisivel) {
      this.messagemVisivel = false;
    }
  }

  limparFormulario() {
    this.form?.reset();
    this.isUfSelecionada = false;
  }

  rolarTela() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  ocultarMsg() {
    this.messagemVisivel = false;
  }

}
